/*!
 * @Instruduction: 监测后台服务接口
 * 模块一后端仅提供两个接口：mini-health / dashboard
 * 路径前缀：/v1/monitor
 */

import xhr from './xhr/index'
import { ICommonResponse } from './index'
import { ITrendRange } from '../types/monitor-types'

/** 基础路径（http.ts 已自动添加 /v1 前缀） */
const BASE = '/monitor'

class MonitorService {
    /**
     * 迷你健康卡（运营后台顶栏入口弹窗）
     * GET /v1/monitor/mini-health
     *
     * status 非 200（如 421）时 data 为 null，前端按通用错误处理：
     * - 网络异常由 xhr/common-handler 统一提示
     * - 业务异常（status≠200）由调用方静默保留占位，避免每次进页面都弹提示
     */
    public async getMiniHealth(): Promise<ICommonResponse> {
        const result = await xhr({
            method: 'get',
            url: `${BASE}/mini-health`,
            params: null
        })
        return result
    }

    /**
     * 仪表盘 6 项横向指标卡（轮询接口）
     * GET /v1/monitor/realtime-cards
     *
     * - 无请求参数；时间范围固定「今日 00:00 ~ 当前」
     * - 前端 15s 轮询；页面不可见时暂停
     * - status 非 200（如 421）时 data 为 null，按通用错误处理
     */
    public async getRealtimeCards(): Promise<ICommonResponse> {
        const result = await xhr({
            method: 'get',
            url: `${BASE}/realtime-cards`,
            params: null
        })
        return result
    }

    /**
     * 仪表盘「01 · 请求量趋势」曲线
     * GET /v1/monitor/trend?range=24h|3d|7d|30d
     *
     * - 切档时调用一次，不轮询（后端已缓存，轮询无意义）
     * - range 省略或非法 → 后端回落 24h，响应 range 字段返回实际生效档位
     * - status 非 200 时 data 为 null，按通用错误处理
     */
    public async getTrend(range?: ITrendRange): Promise<ICommonResponse> {
        const result = await xhr({
            method: 'get',
            url: `${BASE}/trend`,
            params: range ? { range } : null
        })
        return result
    }
}

// 实例化后导出，全局单例
export default new MonitorService()